<script setup lang="ts">
import { resolveRouteName, resolveButterUrl } from '@/utils/utils'

defineProps(['upperFooterData'])
</script>
<template>
  <div class="3xl:min-w-[255px] flex flex-col lg:min-w-[170px] md:items-center">
    <ul class="leading-normal 3xl:text-lg">
      <p
        class="self-start mb-[40px] lg:mb-[20px] text-lg lg:leading-[24px] leading-normal lg:text-xl lg:font-bold"
      >
        {{ upperFooterData?.footer_column_two_title }}
      </p>
      <li class="mb-[20px] lg:mb-[10px]">
        <a
          :href="resolveButterUrl(upperFooterData?.footer_column_two_links?.[0]?.link) + '/'"
          class="leading-normal hover:underline"
          >{{ upperFooterData?.footer_column_two_links?.[0]?.label }}</a
        >
      </li>
      <li class="mb-[20px] lg:mb-[10px]">
        <a
          :href="resolveRouteName(upperFooterData?.footer_column_two_links?.[1]?.link)"
          class="leading-normal lg:relative hover:underline text-nowrap"
          >{{ upperFooterData?.footer_column_two_links?.[1]?.label }}</a
        >
      </li>
      <li class="mb-[20px] lg:mb-[10px]">
        <a
          :href="resolveRouteName(upperFooterData?.footer_column_two_links?.[2]?.link)"
          class="leading-normal hover:underline"
          >{{ upperFooterData?.footer_column_two_links?.[2]?.label }}</a
        >
      </li>
      <li class="mb-[20px] lg:mb-[10px]">
        <a
          :href="resolveRouteName(upperFooterData?.footer_column_two_links?.[3]?.link)"
          class="static leading-normal lg:relative hover:underline"
          >{{ upperFooterData?.footer_column_two_links?.[3]?.label }}</a
        >
      </li>
      <li class="">
        <a
          :href="resolveRouteName(upperFooterData?.footer_column_two_links?.[4]?.link)"
          class="static leading-normal lg:absolute hover:underline"
        >
          {{ upperFooterData?.footer_column_two_links?.[4]?.label }}</a
        >
      </li>
    </ul>
  </div>
</template>
